// extracted by mini-css-extract-plugin
export default {"profile-icon":"profile-icon_profile-icon__feIBZ"};